import { SmartWearEligibility, SmartWearOrderVerifyResponse } from 'api/odinApi';
import { CustomerSubscription } from 'interfaces/ApiTypeAliases';
import { statusCodes } from '../PageSmartWear/constants';

export const mobileMenuDetails = {
  productType: 'Mobile',
  phoneNumber: '12345678',
  subscriptionId: 'MOCK_MOBILE',
};

export const mobileCoreMock = {
  paysForAccount: true,
  productCode: 'SP01_758_34_MOBIL',
  category: 'MOBILE',
  msisdn: '12345678',
  userTest: 'beta',
  employee: true,
  subscriptionId: '123',
};

export const mobileSavingsMock = { savingsAmount: 0, savingsCode: 0 };

export const subscriptionHeaderMock = {
  product: {
    packageProductName: null,
    packageRecurringChargeAmountVat: 0.0,
    productName: 'Mobil Fri Tale & 3 GB Basis',
    productCode: 'SP01_756_67_MOBIL',
    category: 'MOBILE',
    recurringChargeAmountVat: 169.0,
    pin: '1277',
    puk: '35623278',
  },
  includedProducts: [
    { productName: '4G Hastighed', cmsRef: 'C3289604' },
    { productName: 'Fri sms og mms', cmsRef: 'C3291303' },
    { productName: 'Roaming Europe', cmsRef: 'ROAMING_EUEUROPE' },
    { productName: 'Voicemail', cmsRef: 'C3282907' },
  ],
  extraProducts: [{ productName: '5 GB ekstra data', cmsRef: 'C3282506' }],
};

export const mobileSimcardMock = {
  voiceMailNo: '20171717',
  msisdn: '21350162',
  simcardDetails: [
    {
      simNo: '89450120210409031516',
      puk: '35623278',
      status: 'ACTIVE',
      primarySim: true,
      bestillingsdato: null,
      bestillingsId: null,
      pin: '1277',
      esim: true,
    },
  ],
};

export const usageSpecificationsMockOdin = {
  accountNumber: 204045988,
  verified: true,
  verificationState: 'Unknown',
  startDate: '2020-05-04T00:00:00',
  endDate: '2020-05-11T23:59:59',
  usages: [
    {
      usage: { unit: 'Data', value: '89932.3564453125' },
      usageDateTime: '2020-05-04T08:34:06',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Data', value: '93207.134765625' },
      usageDateTime: '2020-05-04T08:56:00',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Time', value: '00:01:00' },
      usageDateTime: '2020-05-04T17:09:29',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: '92443395',
      groupCode: '18800400',
      rlah: false,
      groupDescription: 'Opkald til mobil',
    },
    {
      usage: { unit: 'Data', value: '3.46875' },
      usageDateTime: '2020-05-05T00:31:06',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Data', value: '90363.2724609375' },
      usageDateTime: '2020-05-05T17:47:33',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Time', value: '00:02:00' },
      usageDateTime: '2020-05-05T19:40:28',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: '92443395',
      groupCode: '18800400',
      rlah: false,
      groupDescription: 'Opkald til mobil',
    },
    {
      usage: { unit: 'Data', value: '49923.0087890625' },
      usageDateTime: '2020-05-05T19:58:41',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Time', value: '00:28:00' },
      usageDateTime: '2020-05-05T21:14:43',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: '0034685185990',
      groupCode: '19810200',
      rlah: false,
      groupDescription: 'Opkald til udlandet',
    },
    {
      usage: { unit: 'Data', value: '93516.4541015625' },
      usageDateTime: '2020-05-06T08:30:59',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Data', value: '24.48046875' },
      usageDateTime: '2020-05-06T21:59:22',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Data', value: '1280.08984375' },
      usageDateTime: '2020-05-07T11:36:02',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Time', value: '00:01:00' },
      usageDateTime: '2020-05-08T19:01:12',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: '71623059',
      groupCode: '18800400',
      rlah: false,
      groupDescription: 'Opkald til mobil',
    },
    {
      usage: { unit: 'Data', value: '563.568359375' },
      usageDateTime: '2020-05-08T23:17:07',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Data', value: '89877.0830078125' },
      usageDateTime: '2020-05-09T00:16:53',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Data', value: '70896.283203125' },
      usageDateTime: '2020-05-09T01:08:11',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Data', value: '95595.7958984375' },
      usageDateTime: '2020-05-09T08:35:08',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Data', value: '59160.01171875' },
      usageDateTime: '2020-05-09T15:08:55',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Time', value: '00:04:00' },
      usageDateTime: '2020-05-09T18:00:41',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: '0039087186695',
      groupCode: '19810200',
      rlah: false,
      groupDescription: 'Opkald til udlandet',
    },
    {
      usage: { unit: 'Data', value: '89943.423828125' },
      usageDateTime: '2020-05-10T08:40:15',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Data', value: '97223.31640625' },
      usageDateTime: '2020-05-10T08:55:47',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Data', value: '85933.4375' },
      usageDateTime: '2020-05-10T16:10:29',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
    {
      usage: { unit: 'Data', value: '32085.16015625' },
      usageDateTime: '2020-05-10T16:40:58',
      freeOfVat: false,
      amount: 0.0,
      subscriptionId: '92443427',
      calledNumber: ' ',
      groupCode: '19882500',
      rlah: false,
      groupDescription: 'Dataforbrug',
    },
  ],
  canShowUsages: true,
};

export const usageOverviewMockFreeData = {
  voiceUsageInformation: { limit: 0, usage: 10620 },
  dataUsageInformation: { limit: 0, usage: 28153310 },
  euDataUsageInformation: { limit: 20971520, usage: 0 },
  xmsUsageInformation: { limit: 0, usage: 0 },
  internationalVoiceUsageInformation: { limit: 7200, usage: 0 },
  internationalSmsUsageInformation: { limit: 20, usage: 0 },
  hasSharedData: false,
  remainingDays: 3,
  roamingType: 'ROAMING_WORLD',
  package: false,
  roamingWorld: true,
};

// taken from selfcare_13
export const fetchCardsMock = [
  {
    msisdn: '61226115',
    subscriptionName: 'Mobil Fri Tale & 40 GB Basis',
    price: 299.0,
    dataUsageInformation: { limit: 1888576000, usage: 0, unitType: 'kb' },
    euDataUsageInformation: { limit: 629251, usage: 0, unitType: 'kb' },

    remainingDays: 31,
    roamingType: 'ROAMING_EU',
  },
  {
    msisdn: '61227858',
    subscriptionName: 'YouSee Mobilt Bredbånd 1 TB',
    price: 449.0,
    dataUsageInformation: { limit: 1048576000, usage: 0, unitType: 'kb' },
    euDataUsageInformation: { limit: 629, usage: 0, unitType: 'kb' },
    remainingDays: 31,
    roamingType: 'ROAMING_DK',
  },
  {
    msisdn: '61636750',
    subscriptionName: 'Fri Tale & 3 GB Basis',
    price: 438.0,
    dataUsageInformation: { limit: 8388608, usage: 0, unitType: 'kb' },
    euDataUsageInformation: null,
    remainingDays: 31,
    roamingType: null,
  },
  {
    msisdn: '61636697',
    subscriptionName: 'Fri Tale & 10 GB Basis',
    price: 169.0,
    dataUsageInformation: { limit: 27262976, usage: 0, unitType: 'kb' },
    euDataUsageInformation: { limit: 15728640, usage: 0, unitType: 'kb' },
    remainingDays: 31,
    roamingType: 'ROAMING_EU',
  },
  {
    msisdn: '62604017',
    subscriptionName: 'Mobil Fri Tale / 60 GB',
    price: 139.0,
    dataUsageInformation: { limit: 62914560, usage: 0, unitType: 'kb' },
    euDataUsageInformation: { limit: 10485760, usage: 0, unitType: 'kb' },
    remainingDays: 31,
    roamingType: 'ROAMING_EU',
  },
  {
    msisdn: '62604866',
    subscriptionName: 'Fri Tale / 50 GB',
    price: 199.0,
    dataUsageInformation: { limit: 52428800, usage: 0, unitType: 'kb' },
    euDataUsageInformation: { limit: 15728640, usage: 0, unitType: 'kb' },
    remainingDays: 31,
    roamingType: 'ROAMING_EU',
  },
  {
    msisdn: '62605479',
    subscriptionName: 'Fri Tale / 40 GB',
    price: 179.0,
    dataUsageInformation: { limit: 41943040, usage: 0, unitType: 'kb' },
    euDataUsageInformation: { limit: 15728640, usage: 0, unitType: 'kb' },
    remainingDays: 31,
    roamingType: 'ROAMING_EU',
  },
  {
    msisdn: '62605510',
    subscriptionName: 'Fri Tale / Fri Data',
    price: 299.0,
    dataUsageInformation: { limit: 0, usage: 0, unitType: 'kb' },
    euDataUsageInformation: { limit: 26214400, usage: 0, unitType: 'kb' },
    remainingDays: 31,
    roamingType: 'ROAMING_WORLD',
  },
  {
    msisdn: '62621451',
    subscriptionName: 'Fri Tale/ 30 GB',
    price: 179.0,
    dataUsageInformation: { limit: 31457280, usage: 0, unitType: 'kb' },
    euDataUsageInformation: { limit: 15728640, usage: 0, unitType: 'kb' },
    remainingDays: 31,
    roamingType: 'ROAMING_EU',
  },
];

export const mobileUpgradeMock = {
  canChange: true,
  productCode: 'SP01_758_34_MOBIL',
  hasDobbeltData: false,
  basisProduct: { msisdn: '21350162', name: 'Fri + Fri Data', cmsRef: 'C0175838', youSeeMore: [] },
  extraProducts: [],
};

// SIM state 1- One active simcard, no order, no awaiting activation
export const activeSimcardMock = {
  primarySimInfo: {
    simNo: '89450130140110271111',
    puk1: '34991111',
    msisdn: '61230740',
    status: 'Active',
    voiceMailNumber: '20171717',
    isEsim: false,
  },
  newSimProduct: {
    oneTimePrice: 99,
    esimOneTimePrice: 0,
    changeCode: null,
    orderId: null,
    orderDate: '0001-01-01T00:00:00',
    osmMail: 'test@nuuday.dk',
  },
  activationInfo: {
    readyForActivation: false,
    simNo: '',
    activationLastFourNo: '',
    changeLog: null,
    PIN: null,
    qrUrl: null,
    isEsim: false,
  },
  mockApiServer: { workflowState: '1' },
};

// SIM state 2- Just placed order
export const orderedSimcardMock = {
  primarySimInfo: {
    simNo: '89450130140110271111',
    puk1: '34991111',
    msisdn: '61230740',
    status: 'Active',
    voiceMailNumber: '20171717',
    isEsim: false,
  },
  newSimProduct: {
    oneTimePrice: 99,
    esimOneTimePrice: 0,
    changeCode: 'Buy',
    orderId: 'SSCR000032752',
    orderDate: '2021-05-21T09:06:49',
    osmMail: 'test@nuuday.dk',
  },
  activationInfo: {
    readyForActivation: false,
    simNo: '',
    activationLastFourNo: '',
    changeLog: null,
    PIN: null,
    qrUrl: null,
    isEsim: false,
  },
  mockApiServer: { workflowState: '2' },
};

// SIM state 4a- Ready for activation of sim card, with active being a sim card
export const readyForActivation = {
  primarySimInfo: {
    simNo: '89450130140110271111',
    puk1: '34991111',
    msisdn: '61230740',
    status: 'Active',
    voiceMailNumber: '20171717',
    isEsim: false,
  },
  newSimProduct: {
    oneTimePrice: 99,
    esimOneTimePrice: 0,
    changeCode: null,
    orderId: null,
    orderDate: '2022-01-06T12:39:40',
    osmMail: 'test@nuuday.dk',
  },
  activationInfo: {
    readyForActivation: true,
    simNo: '89450130210111082222',
    activationLastFourNo: '2222',
    changeLog: null,
    PIN: null,
    qrUrl: null,
    isEsim: false,
  },
  mockApiServer: { workflowState: '4a' },
};

// SIM state 5 - pending activation
export const pendingActivation = {
  primarySimInfo: {
    simNo: '89450130140110271111',
    puk1: '34991111',
    msisdn: '61230740',
    status: 'Active',
    voiceMailNumber: '20171717',
    isEsim: false,
  },
  newSimProduct: {
    oneTimePrice: 99,
    esimOneTimePrice: 0,
    changeCode: null,
    orderId: null,
    orderDate: '0001-01-01T00:00:00',
    osmMail: 'test@nuuday.dk',
  },
  activationInfo: {
    readyForActivation: false,
    simNo: '',
    activationLastFourNo: '',
    changeLog: {
      changeCode: 'PendingActivation',
      orderId: '27533716',
      orderDate: '2021-06-10T00:00:00',
    },
    PIN: null,
    qrUrl: null,
    isEsim: false,
  },
  mockApiServer: {
    workflowState: '5',
  },
};

//
// E-sim
//

// eSIM state 1- One active eSIM, no order, no awaiting activation
export const activeEsimMock = {
  primarySimInfo: {
    simNo: '33668888140110271111',
    puk1: '65981111',
    msisdn: '61230740',
    status: 'Active',
    voiceMailNumber: '20171717',
    isEsim: true,
  },
  newSimProduct: {
    oneTimePrice: 99,
    esimOneTimePrice: 0,
    changeCode: null,
    orderId: null,
    orderDate: '0001-01-01T00:00:00',
    osmMail: 'test@nuuday.dk',
  },
  activationInfo: {
    readyForActivation: false,
    simNo: '',
    activationLastFourNo: '',
    changeLog: null,
    PIN: null,
    qrUrl: null,
    isEsim: false,
  },
  mockApiServer: { workflowState: 'esimState1' },
};

// eSIM state 2- Just ordered e-sim
export const orderedEsim = {
  primarySimInfo: {
    simNo: '89450120200623033299',
    puk1: '93462231',
    msisdn: '51739416',
    status: 'Active',
    voiceMailNumber: '20171717',
    isEsim: true,
  },
  newSimProduct: {
    oneTimePrice: 99,
    esimOneTimePrice: 0,
    changeCode: 'Buy',
    orderId: 'SSCR020340052',
    orderDate: '2022-10-18T10:41:02',
    osmMail: 'mail@steffensorensen.dk',
  },
  activationInfo: {
    readyForActivation: false,
    simNo: '',
    activationLastFourNo: '',
    changeLog: null,
    PIN: null,
    qrUrl: null,
    isEsim: false,
  },
};

// eSIM state 3- Ready for installation e-sim
export const installingEsim = {
  primarySimInfo: {
    simNo: '89450120210705038371',
    puk1: '96463453',
    msisdn: '51739416',
    status: 'Inactive',
    voiceMailNumber: '20171717',
    isEsim: true,
  },
  newSimProduct: {
    oneTimePrice: 99,
    esimOneTimePrice: 0,
    changeCode: 'Buy',
    orderId: 'SSCR020340052',
    orderDate: '2022-10-18T10:41:02',
    osmMail: 'mail@steffensorensen.dk',
  },
  activationInfo: {
    readyForActivation: true,
    simNo: '',
    activationLastFourNo: '',
    changeLog: null,
    PIN: null,
    qrUrl: null,
    isEsim: true,
  },
};

// States for the endpoint: /sim/data

const commonSimDetails = {
  subscribed: true,
  recurringPrice: 30.0,
  billingCyclePeriod: 'Quarterly',
  addOnType: 'DataSimCard',
  oneTimePrice: 0.0,
  changePrice: 99.0,
  orderDate: '2021-11-05T12:56:37',
  addOnProducts: null,
  osmMail: 'maich@nuuday.dk',
  electronicDelivery: true,
};

const uniqueDataSim1 = {
  value: {
    simNo: '89450130200323728831',
    puk1: '90096561',
    msisdn: '20527491',
    status: 'Active',
    voiceMailNumber: null,
    isEsim: false,
  },
  productCode: 'AP32_428_31_PR',
  productName: 'Datadeling 1',
  cmsRef: 'C3242831',
  changeCode: null,
  orderId: 'SSCR018612901',
  ...commonSimDetails,
};

const uniqueDataSim2 = {
  value: {
    simNo: '89450130200323728832',
    puk1: '90096562',
    msisdn: '20527492',
    status: 'Active',
    voiceMailNumber: null,
    isEsim: false,
  },
  productCode: 'AP32_428_32_PR',
  productName: 'Datadeling 2',
  cmsRef: 'C3242832',
  changeCode: null,
  orderId: 'SSCR018612902',
  ...commonSimDetails,
};

const uniqueDataSim3 = {
  value: {
    simNo: '89450130200323728833',
    puk1: '90096563',
    msisdn: '20527493',
    status: 'Active',
    voiceMailNumber: null,
    isEsim: false,
  },
  productCode: 'AP32_428_33_PR',
  productName: 'Datadeling 3',
  cmsRef: 'C3242833',
  changeCode: null,
  orderId: 'SSCR018612903',
  ...commonSimDetails,
};

const freeDataState = {
  dataSims: [],
  pricePerSim: 0,
  totalSims: 0,
  availableSims: 0,
  createPrice: 0,
};

const freeDataStateOneActiveDataSim = {
  dataSims: [uniqueDataSim1],
  pricePerSim: 30.0,
  totalSims: 0,
  availableSims: 0,
  createPrice: 0,
};

// One active data sharing sim
const state1 = {
  dataSims: [uniqueDataSim1],
  totalSims: 3,
  availableSims: 2,
  pricePerSim: 30.0,
  createPrice: 0.0,
};

// No data sharing sims
const state2 = {
  dataSims: [],
  totalSims: 3,
  availableSims: 3,
  pricePerSim: 30.0,
  createPrice: 0.0,
};

// Order just placed
const state3 = {
  dataSims: [
    {
      ...uniqueDataSim1,
      value: {
        simNo: null,
        puk1: null,
        msisdn: null,
        status: 'Inactive',
        voiceMailNumber: null,
        isEsim: false,
      },
      changeCode: 'Buy',
      subscribed: false,
    },
  ],
  totalSims: 3,
  availableSims: 2,
  pricePerSim: 30.0,
  createPrice: 0.0,
};

// Few days after order placed
const state4 = {
  dataSims: [
    {
      ...uniqueDataSim1,
      value: {
        ...uniqueDataSim1.value,
        status: 'Active',
      },
      changeCode: 'Buy',
    },
  ],
  totalSims: 3,
  availableSims: 2,
  pricePerSim: 30.0,
  createPrice: 0.0,
};

// Ready for activation
// Only reordering of data sharing card will reach this state and must be
// activated by the user.
const state5 = {
  dataSims: [
    {
      ...uniqueDataSim1,
      value: {
        ...uniqueDataSim1.value,
        puk1: null,
        status: 'Inactive',
      },
      productCode: 'AP32_428_31_REGISTRE',
      changeCode: null,
      orderId: null,
      addOnType: 'Selectable',
      addOnProducts: [],
      orderDate: '0001-01-01T00:00:00',
    },
  ],
  totalSims: 3,
  availableSims: 2,
  pricePerSim: 30.0,
  createPrice: 0.0,
};

// Just activated - will be active within a few hours
const state6 = {
  dataSims: [
    {
      ...uniqueDataSim1,
      value: {
        ...uniqueDataSim1.value,
        puk1: null,
        status: 'Inactive',
      },
      productCode: 'AP32_428_31_REGISTRE',
      changeCode: 'PendingActivation',
      addOnType: 'Selectable',
      orderId: 'SSCR018830682',
      orderDate: '2021-12-08T09:04:49',
    },
  ],
  totalSims: 3,
  availableSims: 2,
  pricePerSim: 30.0,
  createPrice: 0.0,
};

// Unsubscribe in progress
const state7 = {
  dataSims: [
    {
      ...uniqueDataSim1,
      value: {
        ...uniqueDataSim1.value,
        status: 'Active',
      },
      changeCode: 'Delete',
    },
  ],
  totalSims: 3,
  availableSims: 2,
  pricePerSim: 30.0,
  createPrice: 0.0,
};

// Sim blocked
const state8 = {
  dataSims: [
    {
      ...uniqueDataSim1,
      value: {
        ...uniqueDataSim1.value,
        status: 'ChangeInProgress',
      },
      changeCode: 'Blocked',
    },
  ],
  totalSims: 3,
  availableSims: 2,
  pricePerSim: 30.0,
  createPrice: 0.0,
};

// No sims and not possible to order any sims
export const state9 = {
  dataSims: [],
  totalSims: 0,
  availableSims: 0,
  pricePerSim: 0.0,
  createPrice: 0.0,
};

// Reorder just placed
const state10 = {
  dataSims: [
    {
      value: {
        simNo: '89450130210817349896',
        puk1: '53789844',
        msisdn: '20167954',
        status: 'Active',
        voiceMailNumber: null,
        isEsim: false,
      },
      productCode: 'AP32_428_01_PR',
      productName: 'Datadeling 1',
      cmsRef: 'C3242401',
      subscribed: true,
      recurringPrice: 0.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'DataSimCard',
      oneTimePrice: 0.0,
      changePrice: 99.0,
      changeCode: 'Buy',
      orderId: '51104410',
      orderDate: '2022-07-26T00:00:00',
      addOnProducts: null,
      osmMail: 'stsoer@nuuday.dk',
      electronicDelivery: true,
    },
  ],
  totalSims: 3,
  availableSims: 2,
  pricePerSim: 29.0,
  createPrice: 0.0,
};

// two data sims ready to activate
const state11 = {
  dataSims: [
    {
      value: {
        simNo: '89450130210817397309',
        puk1: '14616044',
        msisdn: '29314645',
        status: 'Active',
        voiceMailNumber: null,
        isEsim: false,
      },
      productCode: 'AP32_428_31_PR',
      productName: 'Datadeling 1',
      cmsRef: 'C3242831',
      subscribed: true,
      recurringPrice: 30.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'DataSimCard',
      oneTimePrice: 0.0,
      changePrice: 99.0,
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: null,
      osmMail: 'stsoer@nuuday.dk',
      electronicDelivery: true,
    },
    {
      value: {
        simNo: '89450130220530456134',
        puk1: null,
        msisdn: '21761709',
        status: 'Inactive',
        voiceMailNumber: null,
        isEsim: false,
      },
      productCode: 'AP66_072_02_REGISTRE',
      productName: 'Datadeling 2',
      cmsRef: 'C6607202',
      subscribed: true,
      recurringPrice: 0.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'Selectable',
      oneTimePrice: 0.0,
      changePrice: 0.0,
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      osmMail: 'stsoer@nuuday.dk',
      electronicDelivery: true,
    },
    {
      value: {
        simNo: '89450130220530499704',
        puk1: '13520520',
        msisdn: '21761709',
        status: 'Active',
        voiceMailNumber: null,
        isEsim: false,
      },
      productCode: 'AP32_428_32_PR',
      productName: 'Datadeling 2',
      cmsRef: 'C3242832',
      subscribed: true,
      recurringPrice: 30.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'DataSimCard',
      oneTimePrice: 0.0,
      changePrice: 99.0,
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: null,
      osmMail: 'stsoer@nuuday.dk',
      electronicDelivery: true,
    },
    {
      value: {
        simNo: '89450130220530456175',
        puk1: null,
        msisdn: '24760403',
        status: 'Inactive',
        voiceMailNumber: null,
        isEsim: false,
      },
      productCode: 'AP66_072_03_REGISTRE',
      productName: 'Datadeling 3',
      cmsRef: 'C6607203',
      subscribed: true,
      recurringPrice: 0.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'Selectable',
      oneTimePrice: 0.0,
      changePrice: 0.0,
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      osmMail: 'stsoer@nuuday.dk',
      electronicDelivery: true,
    },
    {
      value: {
        simNo: '89450130220530499779',
        puk1: '06541062',
        msisdn: '24760403',
        status: 'Active',
        voiceMailNumber: null,
        isEsim: false,
      },
      productCode: 'AP32_428_33_PR',
      productName: 'Datadeling 3',
      cmsRef: 'C3242833',
      subscribed: true,
      recurringPrice: 30.0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'DataSimCard',
      oneTimePrice: 0.0,
      changePrice: 99.0,
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: null,
      osmMail: 'stsoer@nuuday.dk',
      electronicDelivery: true,
    },
  ],
  totalSims: 3,
  availableSims: 0,
  pricePerSim: 30.0,
  createPrice: 0.0,
};

// Unsubscribe data sharing sim response
export const simDataDeleteResponseOk = {
  productName: 'Datadeling 1',
  parentProductName: 'Datadeling',
  subscriptionId: '41D58121CFB377E32566E31C16F260CA',
  orderId: 'SSCR018612910',
  orderDate: '2021-11-05T12:56:37+01:00',
  cmsRef: 'C3242831',
  email: 'john@doe.com',
};

// Order and reorder data sharing sim response
export const simDataOrderResponseOk = {
  productName: 'Datadeling 1',
  parentProductName: '',
  orderId: '33000032752',
  orderDate: '2021-11-29T09:06:49',
  cmsRef: 'C3242831',
  email: 'test@nuuday.dk',
};

export const simulatedErrorResponseSimDataReorder = {
  errors: { subscriptionId: ['The input was not valid.'] },
  type: 'https://tools.ietf.org/html/rfc7231#section-6.5.1',
  title: 'One or more validation errors occurred.',
  status: 400,
  traceId: '|db08426b-4d42cdc46917c810.',
};

export const simulatedErrorResponse = {
  statusCode: 500,
  body: {
    'errorId': null,
    'errorTime': '2021-06-09T11:07:21.4400054+02:00',
    'errorCode': 0,
    'request ID': '8000e3a2-0003-f100-b63f-84710c7967bb',
  },
};

export const tooManySimsOrdersResponse = {
  statusCode: 500,
  body: {
    'errorId': null,
    'errorTime': '2021-11-30T08:53:53.1327235+01:00',
    'errorCode': 10023,
    'request ID': '8002f1d4-0002-dc00-b63f-84710c7967bb',
  },
};

export const allSimDataStates = {
  state1,
  state2,
  state3,
  state4,
  state5,
  state6,
  state7,
  state8,
  state9,
  state10,
  state11,
  uniqueDataSim1,
  uniqueDataSim2,
  uniqueDataSim3,
  freeDataState,
  freeDataStateOneActiveDataSim,
};

export const allSimDataResponses = {
  simDataDeleteResponseOk,
  simDataOrderResponseOk,
  simulatedErrorResponseSimDataReorder,
  simulatedErrorResponse,
  tooManySimsOrdersResponse,
};

export const isEligible: SmartWearEligibility = {
  pendingOrder: false,
  isEmployee: false,
  carrierPostData: 'eyJtZG4iOiIwMDAwMDAwMDAwMCIsImltcyI6IjAwMDAwMDAwMDAwIn0=',
  eSimEligibilityStatus: statusCodes.isEligible,
  eid: '123456789',
  phoneNumber: '4551371267',
  subscriptionId: 'MOCK_MOBILE',
  productName: '',
  productPrice: 30.0,
  originalProductPrice: 0.0,
  hasActiveCampaign: false,
  includedInSubscription: true,
  displayName: "Somone's Apple Watch",
};

export const orderVerification: SmartWearOrderVerifyResponse = {
  orderStatus: 'Provisioned',
  iccId: '123456789',
  smdpAddress: 'the-smdp-address',
};

const carrierPostData = 'bXNpc2RuPTQ1MjAzMDkxNDg7aW3zaT0yMzgxMDIwMDAwMDAwMTA=';
export const webSheetData = {
  carrierPostData,
  phoneNumber: window.atob(carrierPostData).split(';')[0].split('=')[1].substring(2),
  eid: '89049032003408882300002594102035',
  displayName: "Someone's Apple Watch",
};

export const mobileBroadband: CustomerSubscription = {
  role: {
    isPayer: true,
    isOwner: true,
    isUser: true,
    payer: '204078994',
    owner: '5401062586',
    user: '5401062586_1_1',
  },
  aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
  technology: 'MobileNetwork',
  lid: '61145925',
  type: 'PartialSubscription',
  identifier: '4313',
  header: 'YouSee Mobilt Bredbånd 1 TB',
  productCode: 'SP01_757_37_MBB',
  productType: 'MobileBroadband',
  customerPaidAccountNumbers: ['204078994'],
  packageMeta: {
    partOfPackage: false,
    identifier: null,
    packageProductCode: null,
    packageProductName: null,
  },
  addOns: [],
  backwardsCompatibleIdentifier: {
    identifier: 'EE056AA772AD852363163990C202F0FA,SP01_757_37_MBB',
    isEnabled: true,
  },
};

export const getMobileBroadbandSubscriptionsResponse = {
  subscriptionId: 'EE056AA772AD852363163990C202F0FA,SP01_757_37_MBB',
  product: {
    productName: 'Mock data',
    recurringPrice: 42,
  },
};

export const mobile: CustomerSubscription = {
  role: {
    isPayer: true,
    isOwner: true,
    isUser: true,
    payer: '204372367',
    owner: '5110038986',
    user: '5110038986_1_1',
  },
  aggregatedRole: {
    payer: 'Full',
    owner: 'Full',
    user: 'Full',
  },
  technology: 'MobileNetwork',
  lid: '62604866',
  type: 'PartialSubscription',
  identifier: '4322',
  header: 'Fri Tale / 50 GB',
  productCode: 'SP01_758_08_MOBIL',
  productType: 'Mobile',
  customerPaidAccountNumbers: ['204372367'],
  packageMeta: {
    partOfPackage: false,
    identifier: null,
    packageProductCode: null,
    packageProductName: null,
  },
  addOns: [],
  backwardsCompatibleIdentifier: {
    identifier: 'BF735DA5765A358FCF51981EFAAB4919,SP01_758_08_MOBIL',
    isEnabled: true,
  },
};

export const getSubscriptionsResponse = {
  subscriptionId: 'BF735DA5765A358FCF51981EFAAB4919,SP01_758_08_MOBIL',
  product: {
    productName: 'Mock data',
    recurringPrice: 42,
  },
};
